import QrNotice from '@/shared/publish/Homework/QrNotice';
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/publish/Homework/QrNotice')({
  component: RouteComponent,
})

function RouteComponent() {
  return <QrNotice />
}
